import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useSnackbar } from 'notistack';
import type { GridRowId, GridRowSelectionModel } from '@mui/x-data-grid-premium';

export type SingleRowSelectionError = 'empty' | 'multiple' | null;

export const getSingleRowSelectionError = (selection: GridRowSelectionModel): SingleRowSelectionError => {
  if (selection.length === 0) return 'empty';
  if (selection.length > 1) return 'multiple';

  return null;
};

const useSingleRowSelectionGuard = () => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();

  return useCallback(
    (selection: GridRowSelectionModel): GridRowId | null => {
      const error = getSingleRowSelectionError(selection);

      if (error === 'empty') {
        enqueueSnackbar(
          intl.formatMessage({ id: 'checkbox.noSelection', defaultMessage: 'Lütfen en az 1 satır seçiniz!' }),
          { variant: 'warning' }
        );
        return null;
      }

      if (error === 'multiple') {
        enqueueSnackbar(
          intl.formatMessage({ id: 'checkbox.tooSelection', defaultMessage: 'Birden fazla satır seçilemez!' }),
          { variant: 'warning' }
        );
        return null;
      }

      return selection[0];
    },
    [enqueueSnackbar, intl]
  );
};

export default useSingleRowSelectionGuard;
